import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const defaultPageFilters = () => ({
  isAllDomains: false,
  isModifAnnuelle: false,
  forceSelenium: false,
  hasBug: false,
  hasLenteurs: false,
  updatedAfter: '',
  updatedBefore: '',
  requeteIds: [],
})

const state = {
  // ---------- FILTER PAGE WITHOUT CRAWLPAGES PERIOD -------------
  pagesWithoutCrawlpagesStartDate: null,
  pagesWithoutCrawlpagesEndDate: null,
  // ---------- PAGE FILTERS (tree) -------------
  pageFilters: defaultPageFilters(),
}

const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  SET_PAGE_FILTERS (state, filters) {
    state.pageFilters = { ...filters }
  },
  RESET_PAGE_FILTERS (state) {
    state.pageFilters = defaultPageFilters()
  },
}

export default new Vuex.Store({
  modules: {
    user,
    auth,
  },
  strict: debug,
  state,
  mutations
})
